import script from "./bas-de-page.vue?vue&type=script&setup=true&lang=js"
export * from "./bas-de-page.vue?vue&type=script&setup=true&lang=js"

import "./bas-de-page.vue?vue&type=style&index=0&id=73db1e7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73db1e7a"]])

export default __exports__